import type { CardCommentAttachmentUploadPath, UploadPathSuffix } from '../types.js';

export class CardCommentAttachmentPathBuilder {
  public static buildPath(
    accountId: string,
    pipeId: string,
    cardId: string,
    commentId: string,
    fileName: string,
  ): `${CardCommentAttachmentUploadPath}${UploadPathSuffix}` {
    return `accounts/${accountId}/pipes/${pipeId}/cards/${cardId}/comments/${commentId}/files/${fileName}`;
  }

  public static isCardCommentAttachmentPath(path: string): path is `${CardCommentAttachmentUploadPath}${UploadPathSuffix}` {
    const regex = /^accounts\/[^/]+\/pipes\/[^/]+\/cards\/[^/]+\/comments\/[^/]+\/files\/.+$/;
    return regex.test(path);
  }
}
